import { AxiosInstance, CancelToken } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v1/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v1/folder';

export class FolderService implements types.Handlers {
  private readonly endpoint = '/v1/folders';

  constructor(private axios: AxiosInstance) {}
  async createSubFolderFile(
    params: types.CreateSubFolderFileParameters,
  ): Promise<common.CreateFileResponse> {
    const { data } = await this.axios.post<common.CreateFileResponse>(
      `${this.endpoint}/${params.path.folderId}/files`,
      params.body,
    );
    return data;
  }

  async getSubFolderFiles(
    params: types.GetSubFolderFilesParameters,
    cancelToken?: CancelToken,
  ): Promise<common.GetFilesResponse> {
    const { data } = await this.axios.get<common.GetFilesResponse>(
      `${this.endpoint}/${params.path.folderId}/files`,
      {
        params: new URLSearchParams([
          ...(params.query.include ?? []).map((x) => ['include', x]),
          ...(params.query.orderBy ?? []).map((x) => ['orderBy', x]),
        ]),
        cancelToken: cancelToken,
      },
    );
    return data;
  }

  async createSubFolder(
    params: types.CreateSubFolderParameters,
  ): Promise<common.FolderModelResponse> {
    const { data } = await this.axios.post<common.FolderModelResponse>(
      `${this.endpoint}/${params.path.folderId}`,
      params.body,
    );
    return data;
  }

  async getSubFolders(
    params: types.GetSubFoldersParameters,
    cancelToken?: CancelToken,
  ): Promise<common.GetFoldersResponse> {
    const { data } = await this.axios.get<common.GetFoldersResponse>(
      `${this.endpoint}/${params.path.folderId}/folders`,
      {
        params: new URLSearchParams([
          ...(params.query.include ?? []).map((x) => ['include', x]),
          ...(params.query.orderBy ?? []).map((x) => ['orderBy', x]),
        ]),
        cancelToken: cancelToken,
      },
    );
    return data;
  }

  async deleteFolder(params: types.DeleteFolderParameters): Promise<void> {
    await this.axios.delete(`${this.endpoint}/${params.path.folderId}`);
  }

  async patchFolder(params: types.PatchFolderParameters): Promise<common.FolderModelResponse> {
    const { data } = await this.axios.patch<common.FolderModelResponse>(
      `${this.endpoint}/${params.path.folderId}`,
      params.body,
    );
    return data;
  }

  async activateSkyMapConnect(
    params: types.ActivateSkyMapConnectParameters,
  ): Promise<common.FolderModelResponse> {
    const { data } = await this.axios.post<common.FolderModelResponse>(
      `${this.endpoint}/${params.path.folderId}/skymap-connect`,
    );
    return data;
  }

  async deactivateSkyMapConnect(params: types.DeactivateSkyMapConnectParameters): Promise<void> {
    await this.axios.delete(`${this.endpoint}/${params.path.folderId}/skymap-connect`);
  }
}
